import './index.scss';

import { Component, ReactNode } from 'react';

import { BraxRadioOption, BraxRadioValue, UncontrolledField } from '..';
import { BraxButton } from '../../BraxButton';
import { BraxIcon } from '../../BraxIcon';

export type BraxUncontrolledRadioToggleButtonFieldProps<V extends BraxRadioValue> = Omit<UncontrolledField<V>, 'id' | 'name'> & Required<Pick<UncontrolledField<V>, 'name'>> & {
    label?: ReactNode,
    hint?: ReactNode,
    options: BraxRadioOption<V>[],
    required?: boolean,
    disabled?: boolean,
    onChange?: (value: V) => void
};

export class BraxUncontrolledRadioToggleButtonField<V extends BraxRadioValue> extends Component<BraxUncontrolledRadioToggleButtonFieldProps<V>> {

    static defaultProps = {
        disabled: false,
        status: null
    };

    change(value: V) {
        this.props.onChange?.(value);
    }

    render() {
        return (
            <div className={`brax-radio-toggle-button-field ${this.props.status}`}>
                { this.props.label ? (
                    <label>{ this.props.label } { this.props.required ? '*' : null }</label>
                ) : null }

                <div>
                    { this.props.options.map((option, index) => (
                        <BraxButton
                            key={option.id || index}
                            className={option.value === this.props.value ? 'selected' : ''}
                            variant="secondary"
                            disabled={this.props.disabled}
                            onClick={() => this.change(option.value)}
                        >
                            { option.title }
                        </BraxButton>
                    )) }
                </div>

                { this.props.hint ? (
                    <p className="hint">
                        { this.props.status === 'error' ? <BraxIcon icon="exclamation-mark" /> : null }

                        <span>{ this.props.hint }</span>
                    </p>
                ) : null }
            </div>
        );
    }

}
